<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <CategoryForm @submit-requested="submitRequested" :categoryType="this.$route.params.type"/>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import CategoryForm from './CategoryForm.vue'

  export default {
  components: { CategoryForm },
  methods: {
    ...mapActions('categories', ['postCategory']),
    submitRequested (input) {
      this.postCategory(input);
    },
  },
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 